import classNames from 'classnames'
import { PLATFORM_CONFIG } from 'platform-config'
import { DefineComponentProps } from 'utils'
import { LoadingView } from './LoadingView'
import './LoadingComponent.scss'

type LoadingComponentProps = {
  loading: boolean
  color?: string
  hideChildrenWhenLoading?: boolean
  defaultHeight?: string
}

export const LoadingComponent = defineComponent<LoadingComponentProps>({
  props: DefineComponentProps<LoadingComponentProps>(['loading', 'color', 'hideChildrenWhenLoading', 'defaultHeight']),
  setup(props, { slots }) {
    return () => (
      <div class="loading-component-layout">
        {!props.hideChildrenWhenLoading ? slots.default?.() : props.loading ? null : slots.default?.()}
        <div class={classNames('loading-component-container', { loading: props.loading })} style={{ height: props.defaultHeight }}>
          {props.loading ? <LoadingView color={props.color || PLATFORM_CONFIG.colors.primary} style={{ transform: 'scale(1.2)' }} /> : null}
        </div>
      </div>
    )
  },
})
